// gerado por work/gerar_pdp.py - nao editar a mao
(function () {
  function ligar() {
    var alvo = document.getElementById('ionix-sg-overlay') || document.querySelector('.ix-pp');
    if (!alvo) return;
    var raiz = alvo.closest('.product-info') || document.body;
    if (raiz.dataset.ewcLigado === '1') return;
    raiz.dataset.ewcLigado = '1';
    /* confianca */
    /* Geo flag only. The sold-counter half of this script was removed on
       2026-07-28: it generated the number with Math.random(). See the
       commented-out .ix-trend block above. */
    (function(){
      var f=document.getElementById('ix-flag'),c=document.getElementById('ix-country');
      /* country + flag rendered server-side from Shopify Markets (localization.country) */
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
  var pendente = null;
  new MutationObserver(function () {
    clearTimeout(pendente);
    pendente = setTimeout(ligar, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
